const frequencySocial = [
    "Muy frecuente",
    "Frecuente",
    "Poco frecuente",
    "Casi nunca",
  ];
  
  export default frequencySocial;
  